var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-content-layout',{staticClass:"quotes",attrs:{"title":"Ordrer"}},[_c('button-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.checked.length > 0),expression:"checked.length > 0"}],attrs:{"slot":"tools","label":"Overfør til økonomi system"},on:{"click":_vm.sendToSys},slot:"tools"}),(false)?_c('button-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.checked.length > 0),expression:"checked.length > 0"}],attrs:{"slot":"tools","label":"Maker som overført"},on:{"click":_vm.markAsSent},slot:"tools"}):_vm._e(),(false)?_c('button-group-view',{attrs:{"slot":"tools","actions":[
		{
			label: 'Alle',
			value: 'all'
		},
		{
			label: 'Åben',
			value: 'open'
		},
		{
			label: 'Udført',
			value: 'completed'
		},
		{
			label: 'Afventer',
			value: 'pending'
		},
		{
			label: 'Godkendt',
			value: 'approved'
		},
		{
			label: 'Faktureret',
			value: 'invoiced'
		}
	]},slot:"tools",model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}):_vm._e(),_c('button-group-view',{attrs:{"slot":"tools","actions":[
		{
			label: 'Alle',
			value: 'all'
		},
		{
			label: 'Afventer godkendelse',
			value: 'pending'
		},
		{
			label: 'Klar til fakturering',
			value: 'ready'
		}
	]},slot:"tools",model:{value:(_vm.kind),callback:function ($$v) {_vm.kind=$$v},expression:"kind"}}),_c('button-view',{attrs:{"slot":"tools","label":"Opret"},on:{"click":function($event){return _vm.open(null)}},slot:"tools"}),_c('div',{staticClass:"layout"},[_c('date-picker-std-view',{staticClass:"date",attrs:{"status":_vm._monthStatus},on:{"browse":_vm.updateMonthStatus},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_c('div',{staticClass:"tasks"}),_c('new-table-view',{staticClass:"list",attrs:{"columns":[
			{
				label: 'Status',
				name: ['status'],
				translation: _vm._status,
				template: {
					name: 'status',
					params: {
						color: {
							name: ['status'],
							translation: _vm._statusColors
						},
						description: {
							name: ['status'],
							translation: _vm._statusDesc
						}
					}
				}
			},
			{
				label: 'Nr',
				name: 'num',
				filter: 'integer'
				//filter: 'float',
				//align: 'right'
			},
			{
				label: 'Udført',
				name: 'due',
				filter: 'timestamp'
				//filter: 'float',
				//align: 'right'
			},
			/*{
				label: 'E-mail',
				data: '-',
				//filter: 'float',
				//align: 'right'
			},
			{
				label: 'Kontakt',
				data: '-',
				//filter: 'float',
				//align: 'right'
			},*/
			{
				label: 'E-mail',
				name: 'email_sent',
				default: 'Ikke sendt',
				filter: 'days'
				//filter: 'float',
				//align: 'right'
			},
			{
				label: 'Navn',
				name: ['customer', 'name']
			},
			/*{
				label: 'Kunde',
				name: ['_embedded', 'contact', 'name'],
				//filter: 'float',
				//align: 'right'
			},*/
			{
				label: 'Ansvarlig',
				name: ['_embedded', 'employee', 'name'],
				//filter: 'float',
				//align: 'right'
			},
			{
				label: 'Kostpris',
				name: ['cost'],
				filter: 'number'
			},
			{
				label: 'Salgspris',
				name: ['total'],
				filter: 'number'
			},
			{
				label: 'Dæk.bidrag',
				name: ['margin'],
				filter: 'number'
			},
			{
				label: 'Dæk.grad',
				name: ['margin_coeff'],
				filter: 'number'
			},
			{
				label: '',
				name: 'context',
				align: 'right',
				template: {
					name: 'button',
					label: '...'
				}
			}			
		],"items":_vm.items},on:{"itemClick":_vm.itemClick,"context":_vm.itemContext},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }